import React from "react";

import useWindowSize from "../hooks/useWindowSize";
import { Upgrade } from "../types";
import { getPriceFormatted } from "../util";
import Collapsable from "./Collapsable";
import InclusionDetail from "./InclusionDetail";
import MoreDetailsBtn from "./MoreDetailsBtn";
import Selectable from "./Selectable";

// @ts-ignore
const CollapsableImageContent = (props: {
  readonly?: boolean;
  layout: "inclusion" | "upgrade" | "turn_key" | "your_home" | "house_land";
  image: string;
  title: string;
  price: number;
  promo_price?: number;
  fixed_price?: boolean;
  address?: string; // Only used by house and land
  selected: boolean;
  selectableHidden?: boolean;
  insetTick?: boolean;
  onClick?: () => void;
  onClickMoreDetails?: () => void;
  innerHtml?: string;
  children?: JSX.Element;
  showDetailsAsAccordion?: boolean;
  details?: Upgrade | null;
}) => {
  const windowSize = useWindowSize();

  const renderDetails = () => {
    if(props.details){
      return (
        <InclusionDetail
          hideBlurb={true}
          inclusion={props.details}
          hideImages={true}
        />
      );
    }else{
      return (<></>);
    }
  };

  return (
    <div
      className={`pyht-collapsable-image-content layout-${props.layout} ${
        props.readonly ? "readonly" : ""
      }`}
      onClick={() => props.onClick && props.onClick()}
      role={"button"}
    >
      <Selectable
        selected={props.selected}
        hidden={props.selectableHidden}
        insetTick={props.insetTick}
      >
        <div className={"image-container"}>
          <img src={props.image} alt={""} />
        </div>
      </Selectable>
      <div className={`content-container ${props.showDetailsAsAccordion ? "scrollable" : ""}`}>
        <Collapsable
          disabled={props.readonly || windowSize.width >= 992}
          titleContent={
            <>
              <h3 className={"title"}>
                {props.title}
                {props.address && (
                  <>
                    <span className={"comma"}>,</span>{" "}
                    <span className={"address"}>{props.address}</span>
                  </>
                )}
              </h3>
              {props.layout === "house_land" && (
                <p className={"price-title section-label"}>
                  {props.fixed_price ? "Fixed Price" : " "}
                </p>
              )}
              <p className={"price"}>
                <span
                  className={`${
                    props.promo_price !== undefined ? "promo-applied" : ""
                  }`}
                >
                  {getPriceFormatted(props.price)}
                  {props.layout === "house_land" && (
                    <span className={"asterix"}>*</span>
                  )}
                </span>
                {props.promo_price !== undefined && (
                  <span className={"promo-price"}>
                    {getPriceFormatted(props.promo_price)}
                  </span>
                )}
              </p>
            </>
          }
          expandContent={
            <>
              {props.innerHtml ? (
                <div
                  className={"inner-html"}
                  dangerouslySetInnerHTML={{ __html: props.innerHtml }}
                />
              ) : props.children ? (
                props.children
              ) : null}
              {props.showDetailsAsAccordion && props.details ? (
                <>
                  <Collapsable
                    titleContent={<h2 className={"title"}>More Details</h2>}
                    expandContent={renderDetails()}
                    additionalClasses="upgrade-details"
                  />
                </>
              ) : !props.readonly && props.onClickMoreDetails && (
                <MoreDetailsBtn
                  preventDefault={true}
                  onClick={() =>
                    props.onClickMoreDetails && props.onClickMoreDetails()
                  }
                />
              )}
            </>
          }
        />
      </div>
    </div>
  );
};

export default CollapsableImageContent;
